import {
  OTK_COMPANY_CERT_KIND,
  SESSION_INVALIDATING,
  SESSION_SAFE_UPDATE,
} from './otkCompanyCertStateListSync';

export { SESSION_INVALIDATING, SESSION_SAFE_UPDATE };

/** QLTY028 „Podľa firmy“ – stránkovacia jednotka je firma, nie certifikát. */
export const OTK_BY_COMPANY_PAGED_URL = '/api/company_certificates/paged_by_company';
export const OTK_BY_COMPANY_PRINT_URL = '/api/company_certificates/export_by_company/print';
export const OTK_BY_COMPANY_XLSX_URL = '/api/company_certificates/export_by_company/xlsx';

/** Zhodné s CompanyCertificateController::pagedByCompany $allowedSort. */
export const OTK_BY_COMPANY_SORTABLE_FIELDS = Object.freeze([
  'id',
  'name',
  'defined_id',
  'address',
  'email',
  'contact_person',
]);

/** Stĺpec `partner_status_display` je kanonický pre qlty028; qlty026/032 ho vedú ako `company_status_display`. */
export const OTK_BY_COMPANY_FILTER_ALIASES = Object.freeze({
  partner_status_display: 'company_status_display',
});

export function isOtkByCompanySortableField(field) {
  return OTK_BY_COMPANY_SORTABLE_FIELDS.includes(field);
}

export function cleanOtkByCompanySorters(sorters) {
  return (Array.isArray(sorters) ? sorters : [])
    .map((sorter) => ({
      field: sorter?.field ?? sorter?.column,
      dir: sorter?.dir === 'desc' ? 'desc' : 'asc',
    }))
    .filter((sorter) => isOtkByCompanySortableField(sorter.field));
}

export function otkByCompanyShowUrl(companyId, showDeactivatedCerts) {
  const flag = String(showDeactivatedCerts) === '1' ? '1' : '0';
  return `/api/companies/${companyId}?with_otk_certs=1&show_deactivated_certs=${flag}`;
}

export function applyOtkByCompanyHeaderFiltersToParams(extra, headerFilters) {
  (Array.isArray(headerFilters) ? headerFilters : []).forEach((filter) => {
    const field = filter?.field;
    if (!field) return;
    const value = filter.value;
    if (value == null || String(value).trim() === '') return;
    const trimmed = String(value).trim();
    extra[`filter_${field}`] = trimmed;
    const alias = OTK_BY_COMPANY_FILTER_ALIASES[field];
    if (alias) extra[`filter_${alias}`] = trimmed;
  });
  return extra;
}

/** Vznik/zánik certifikátu alebo (de)aktivácia mení eligibility firmy → session sa musí reštartovať. */
const MEMBERSHIP_KINDS = new Set([
  OTK_COMPANY_CERT_KIND.PARENT_CREATED,
  OTK_COMPANY_CERT_KIND.PARENT_DELETED,
  OTK_COMPANY_CERT_KIND.PARENT_ACTIVATED,
  OTK_COMPANY_CERT_KIND.PARENT_DEACTIVATED,
  OTK_COMPANY_CERT_KIND.RECORD_CREATED,
  OTK_COMPANY_CERT_KIND.RECORD_DELETED,
]);

/**
 * Riadok zoznamu je firma, preto zmena vnoreného certifikátu/záznamu je bezpečná len vtedy,
 * keď writer poslal `companyId` a daná firma je načítaná v aktuálnej session.
 */
export function classifyOtkByCompanyCertMutation(event, session = {}) {
  const detail = event?.detail;
  if (!detail || typeof detail !== 'object') return SESSION_INVALIDATING;
  const kind = detail.kind;
  if (!kind || MEMBERSHIP_KINDS.has(kind)) return SESSION_INVALIDATING;
  const companyId = detail.companyId ?? detail.company_id;
  if (companyId == null || companyId === '') return SESSION_INVALIDATING;
  if (typeof session.isRowLoaded !== 'function' || !session.isRowLoaded(companyId)) return SESSION_INVALIDATING;
  if (String(session.toolbarSearch ?? '').trim() !== '') return SESSION_INVALIDATING;
  return SESSION_SAFE_UPDATE;
}

export function otkByCompanyMutationCompanyId(detail) {
  const companyId = detail?.companyId ?? detail?.company_id;
  return companyId == null || companyId === '' ? null : companyId;
}
